export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/sylndr-certified.9fb92c41.svg","height":160,"width":222,"blurWidth":0,"blurHeight":0};